import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero 섹션 */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        {/* 배경 이미지 */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/0aabf109089e1a8aa119c2bbf7ff6cdb.jpg')`
          }}
        ></div>
        
        {/* 다크 오버레이 */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
        
        {/* 콘텐츠 */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="text-left max-w-4xl">
            <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight tracking-wide mb-6">
              한국과 일본을 잇는<br />
              비즈니스 파트너
            </h1>
            <p className="text-xl md:text-2xl text-white/80 mb-8 max-w-3xl">
              무역·교육·콘텐츠를 통해 지속 가능한 글로벌 관계를 만듭니다
            </p>
            <div className="flex items-center space-x-4">
              <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
              <button className="inline-flex items-center px-8 py-4 bg-black text-white text-lg font-medium rounded-full hover:bg-gray-800 transition-colors whitespace-nowrap">
                서비스 알아보기
                <i className="ri-arrow-right-line ml-3"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* About Us 섹션 */}
      <section className="py-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-8">
            <div className="inline-block px-4 py-2 bg-gray-200 text-gray-700 text-sm font-medium rounded-full">
              ABOUT QUANTUMHI
            </div>
            
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
              신뢰와 투명성을 기반으로<br />
              한일 비즈니스를<br />
              연결합니다
            </h2>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              제조 직거래 무역부터 실용 언어 교육, 브랜드 콘텐츠 제작까지<br />
              퀀텀하이는 한국과 일본 간 지속 가능한 파트너십을 만들어갑니다
            </p>
          </div>
        </div>
      </section>

      {/* Services 섹션 */}
      <section className="py-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-16">
            <p className="text-sm text-gray-500 uppercase tracking-wide mb-4">OUR SERVICES</p>
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
              퀀텀하이가 제공하는<br />
              세 가지 핵심 서비스
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Trade 카드 */}
            <div className="bg-white p-8 md:p-10 rounded-2xl">
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className="ri-ship-line text-2xl text-gray-900"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">한국–일본 무역</h3>
              <p className="text-gray-600 leading-relaxed">
                제조사 직접 거래 방식으로 품질 관리부터 출하까지 전 과정을 직접 관리하여 
                안정적이고 신뢰할 수 있는 거래를 지향합니다
              </p>
            </div>

            {/* Language Education 카드 */}
            <div className="bg-white p-8 md:p-10 rounded-2xl">
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className="ri-book-open-line text-2xl text-gray-900"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">외국어 교육</h3>
              <p className="text-gray-600 leading-relaxed">
                영어 및 일본어 1:1 맞춤형 수업을 통해 일상 및 비즈니스 환경에서 
                바로 활용할 수 있는 실용적인 언어 능력 향상을 목표로 합니다
              </p>
            </div>

            {/* Contents 카드 */}
            <div className="bg-white p-8 md:p-10 rounded-2xl">
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className="ri-video-line text-2xl text-gray-900"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">콘텐츠 제작</h3>
              <p className="text-gray-600 leading-relaxed">
                유튜브 및 숏폼 중심의 교육 콘텐츠와 브랜드 콘텐츠를 기획·제작하며, 
                향후 다양한 글로벌 콘텐츠로 확장해 나갈 예정입니다
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Teacher Recruitment CTA 섹션 */}
      <section className="relative py-32 overflow-hidden">
        {/* 배경 이미지 */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Online%20language%20teaching%20scene%2C%20professional%20teacher%20with%20headset%2C%20modern%20home%20office%20setup%2C%20global%20education%20environment%2C%20warm%20and%20inviting%20atmosphere%2C%20international%20connectivity&width=1920&height=1080&seq=teacher-bg-001&orientation=landscape')`
          }}
        ></div>
        
        {/* 오버레이 */}
        <div className="absolute inset-0 bg-gradient-to-r from-orange-900/60 to-orange-700/40"></div>
        
        {/* 콘텐츠 */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-6xl md:text-8xl font-bold text-white mb-8 tracking-wider">
            JOIN OUR TEAM
          </h2>
          <p className="text-2xl md:text-3xl text-white mb-12 leading-relaxed">
            퀀텀하이와 함께<br />
            글로벌 교육의 미래를 만들어갈 강사를 찾습니다
          </p>
          <div className="flex justify-center">
            <div className="flex items-center space-x-4">
              <div className="w-4 h-4 bg-orange-500 rounded-full flex items-center justify-center">
                <i className="ri-user-line text-xs text-white"></i>
              </div>
              <button className="inline-flex items-center px-10 py-4 bg-black text-white text-xl font-medium rounded-full hover:bg-gray-800 transition-colors whitespace-nowrap">
                지원하기
                <i className="ri-arrow-right-up-line ml-3"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Contact 섹션 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              연락처
            </h2>
            <p className="text-xl text-gray-600">
              언제든지 문의해 주세요
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-1 gap-12">
            {/* 연락처 정보 */}
            <div className="space-y-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-xl text-orange-600"></i>
                </div>
                <div>
                  <div>
                    <p className="font-semibold text-gray-900">이메일</p>
                    <p className="text-gray-600">quantumhigh@naver.com</p>
                  </div>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-xl text-orange-600"></i>
                </div>
                <div>
                  <div>
                    <p className="font-semibold text-gray-900">전화</p>
                    <p className="text-gray-600">051-205-0950</p>
                  </div>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-xl text-orange-600"></i>
                </div>
                <div>
                  <div>
                    <p className="font-semibold text-gray-900">주소</p>
                    <p className="text-gray-600">부산광역시강서구명지오션시티9로50</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
